import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom'
import Lang from '../../../components/language/services/Lang'
import ProductBadge from '../../../components/library/badges/ProductBadge'
import Skeleton from '../../../components/library/loaders/Skeleton'
import './TicketBasicInformation.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';

const TicketTitle = (props) => {
    const history = useHistory();
    const { ticket, lang } = props;

    const openClientInfoPage = () => {
        history.push(`/clients/${ticket.targetId}`);
    }

    return (
        <div>
            <div className='columns tickets'>
                <div className='column is-offset-1 is-1 ticket-title-name'> 
                    <ProductBadge productCode={(ticket && ticket.ticketType) ? ticket.ticketType.identifier : ""} />
                </div>
                <div className='column is-8'>
                    {ticket && ticket.name &&
                        <h1>{ticket.name[lang || Lang.getCurrentLanguage().toLowerCase()] || "—"}</h1>
                    }
                    {(!ticket || !ticket.name) &&
                        <Skeleton />
                    }
                </div>
                <div className='column is-2'/>
            </div>
            <div className='columns tickets client-info-link'>
                <div className='column is-offset-1 is-8'>
                    {ticket && ticket.targetId &&
                        <a onClick={openClientInfoPage}><HrbTranslate text='Tickets.Labels.ClientInfoPage' /></a>
                    }
                </div>
            </div>
        </div>
    );
}

TicketTitle.whyDidYouRender = false;

TicketTitle.propTypes = {
    ticket: PropTypes.object,
    lang: PropTypes.string
}

export default TicketTitle